var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "well ovx-auto" },
    [
      _c("div", { staticClass: "flex-level" }, [
        _c("div", { staticClass: "flex fs-4 bold" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$l10n.__("Achats externes")) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex aright" },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("common.actions.impact_profit"),
                type: "secondary",
                disabled: _vm.impactButtonIsDisable
              },
              on: {
                click: function($event) {
                  return _vm.impact()
                }
              }
            }),
            _vm._v(" "),
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__(
                  "documents.overview.tab.margin.Purchase.link_purchase"
                ),
                type: "secondary",
                disabled: !_vm.canImpact,
                onclick:
                  "purchaseTools.linkTo('" +
                  _vm.doctype +
                  "', " +
                  _vm.docid +
                  ");"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: { data: _vm.purchases },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "selection",
              selectable: _vm.canProcess,
              property: "processMargin"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: _vm.$t.__("common.labels.impact_profit") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.displaySaasBoolean(scope.row.processMargin)
                        ) +
                        "\n            "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: _vm.$t.__("common.labels.date") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm._f("saasDateFormatted")(scope.row.date)) +
                        "\n            "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "supplier",
              label: _vm.$t.__("documents.overview.tab.margin.supplier")
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: _vm.$t.__("common.labels.reference") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.canRead
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.buildLink(
                                scope.row.doctype,
                                scope.row.docid
                              )
                            }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(scope.row.ident) +
                                "\n                "
                            )
                          ]
                        )
                      : _c("span", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(scope.row.ident) +
                              "\n                "
                          )
                        ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "ref",
              label: _vm.$t.__(
                "documents.overview.tab.margin.Purchase.external_reference"
              )
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "formatted_totalAmount",
              label: _vm.$t.__(
                "documents.overview.tab.margin.purchase_amount_exclude_tax"
              )
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "formatted_linkedAmount",
              label: _vm.$t.__(
                "documents.overview.tab.margin.Purchase.impacted_amount"
              )
            }
          }),
          _vm._v(" "),
          _vm.canImpact
            ? _c("el-table-column", {
                attrs: { fixed: "right" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "a",
                            {
                              staticClass: "link mr-2",
                              on: {
                                click: function($event) {
                                  return _vm.removeLink(
                                    scope.row,
                                    _vm.context,
                                    scope.row
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$l10n.__("Délier")) +
                                  "\n                "
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1733423712
                )
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.purchases.length > 0
        ? _c("div", { staticClass: "aright fs-3 mt-2" }, [
            _c("span", { staticClass: "mr-4" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$l10n.__("Total achat")) +
                  " : " +
                  _vm._s(_vm._f("numberformatCurrency")(_vm.formattedTotal)) +
                  "\n        "
              )
            ]),
            _vm._v(
              "\n        " +
                _vm._s(_vm.$l10n.__("Total impact")) +
                " : " +
                _vm._s(_vm._f("numberformatCurrency")(_vm.linkedTotal)) +
                "\n    "
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }